<template>
    <div>
        <div class="container-wide login-box">
            <div class="login-title">{{getLabel('LOGIN_TITLE')}}</div>
            <a-form
                @submit="handleSubmit"
                :form="form"
                class='login-form'>
                <a-form-item>
                    <a-input
                        v-decorator="['name', {rules: [{ type: 'email', message: this.getLabel('TIP_EMAIL_WRONG') }, { required: true, message: this.getLabel('TIP_EMAIL_REQUIRED') }]}]"
                        :placeholder="getLabel('LOGIN_INPUT_NAME_PLACEHOLDER')"
                        size="large"
                        autocomplete="off"
                    >
                    </a-input>
                </a-form-item>
                <a-form-item>
                    <a-input
                        v-decorator="['password', {
                            rules: [
                                { required: true, message: this.getLabel('TIP_PWD_REQUIRED') },
                                { validator: checkWrongPassword },
                            ]
                        }]"
                        @focus="passwordFocus"
                        :type='pwdType'
                        :placeholder="getLabel('LOGIN_INPUT_PWD_PLACEHOLDER')"
                        size="large"
                    >
                    </a-input>
                    <span class="login-icon login-eye-close" v-if="pwdType === 'password'" @click="showPassWord"></span>
                    <span class="login-icon login-eye-open" v-if="pwdType === 'text'" @click="hidePassWord"></span>
                </a-form-item>
                <span class="login-forget" @click="forgetPwd">{{getLabel('LOGIN_FORGET_PWD')}}</span>
                <a-form-item style="padding-top:30px;">
                    <a-button type='primary' htmlType='submit' class='login-form-button' size="large" block>
                        {{getLabel('LOGIN_BTN')}}
                    </a-button>
                </a-form-item>
            </a-form>
        </div>
    </div>
</template>

<script>
	import {mapState} from 'vuex';
	import Language from '../util/language';

	export default {
		components: {},
		data () {
			return {
				form: this.$form.createForm(this),
                pwdType: 'password'
			}
		},
		mounted() {

		},
		computed: {
			...mapState({
				language: state => state.main.language,
				isPasswordValid: state => state.main.isPasswordValid
			})
		},
		watch: {
			isPasswordValid: function () {
				this.form.validateFields(['name', 'password'], { force: true });
			}
		},
		methods: {
			handleSubmit: function (e) {
				e.preventDefault();
				this.form.validateFields((err, values) => {
					if (!err) {
						this.$store.dispatch('main/userLogin', values);
					}
				})
			},
            // 显示密码
			showPassWord: function () {
                this.pwdType = 'text';
			},
            // 隐藏密码
			hidePassWord: function () {
				this.pwdType = 'password';
			},
            // 清空密码
			clearPassword: function () {
				this.form.setFieldsValue({password: ''});
			},
            // 获取描述
            getLabel: function (key) {
	            return Language(this.language, key);
            },
            // 忘记密码
			forgetPwd: function () {
				if (this.language === 'zh') {
					this.$router.push('/forget');
                } else {
					this.$router.push('/en/forget');
                }

			},
			checkWrongPassword  (rule, value, callback) {
                if (this.isPasswordValid) {
                	callback();
                } else {
	                callback(this.getLabel('LOGIN_ERROR'));
                }

			},
			passwordFocus: function () {
				this.$store.commit('main/setPasswordValidStatus', true);
			}
        }
	};
</script>

<style lang="less" scoped>
    @import "../assets/less/login";
</style>